import React, { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { string } from 'prop-types';
import { useDispatch, useSelector } from 'react-redux';
import { FileUploader } from '@atoms';
import { Onboarding } from '@templates';
import { Typography, Flex } from '@mixins';
import { theme } from '@styles';
import { routes } from '@constants';
import { ONBOARDING_STEPS } from '@constants/common';
import {
  updateCompanyOnboarding,
  saveFileOnboarding,
  getOnboardingFileLimits,
  deleteFileOnboarding,
} from '@store/company/duck';

import LogoOnboarding from '@assets/images/LogoOnboarding.png';

const CompanyLogoOnboarding = ({ direction }) => {
  const dispatch = useDispatch();
  const history = useHistory();
  const [uploadedFile, setUploadedFile] = useState(null);

  const { saveCompanyLogoOnboardingPhase, onboardingFileLimits, onboardingState } = useSelector(
    store => store.companyStore,
  );

  useEffect(() => {
    if (!Object.keys(onboardingFileLimits).length) {
      dispatch(getOnboardingFileLimits());
    }
  }, []);

  useEffect(() => {
    if (onboardingState?.logoOnDoorFileName) {
      setUploadedFile({ name: onboardingState.logoOnDoorFileName, size: null });
    }
  }, [onboardingState?.logoOnDoorFileName]);

  const handleBack = () => {
    history.push(routes.teamOnboarding, { direction: 'back' });
  };

  const handleNavigateNext = () => {
    history.push(routes.customizeSpaceOnboarding, { direction: 'forward' });
  };

  const handleNext = () => {
    dispatch(
      updateCompanyOnboarding({
        currentStep: ONBOARDING_STEPS.COMPANY_LOGO_ON_DOOR,
        nextStep: ONBOARDING_STEPS.CUSTOM_REQUESTS,
      }),
    );

    handleNavigateNext();
  };

  const handleRemoveFile = () => {
    dispatch(
      deleteFileOnboarding({
        fileType: 'logo',
      }),
    );
  };

  const handleFileSet = file => {
    setUploadedFile(file);
  };

  const handleFileSubmit = file => {
    const logoData = new FormData();

    logoData.append('file', file);
    logoData.append('fileType', 'logo');

    dispatch(saveFileOnboarding(logoData));
  };

  return (
    <Onboarding
      onNext={handleNext}
      direction={direction}
      title="Company Logo on Your Door"
      image={LogoOnboarding}
      showNavigationItems
      currentStep={2}
      onBack={handleBack}>
      <Flex flexDirection="column" maxWidth={600}>
        <Typography
          variant="diatype-300"
          mb={30}
          fontSize={[14, 16, 20]}
          color={theme.color.mintMinded[900]}
          lineHeight="1.6">
          Want your logo displayed on your office door? Upload a vector logo file in{' '}
          <Typography fontWeight={500} as="span">
            {onboardingFileLimits?.logo?.fileType || 'SVG, AI or EPS'}
          </Typography>{' '}
          format
        </Typography>

        <FileUploader
          onFileRemove={handleRemoveFile}
          fileLimits={onboardingFileLimits?.logo}
          file={uploadedFile}
          onFileSubmit={handleFileSubmit}
          onFileSet={handleFileSet}
          requestPhase={saveCompanyLogoOnboardingPhase}
        />
      </Flex>
    </Onboarding>
  );
};

CompanyLogoOnboarding.defaultProps = {
  direction: null,
};

CompanyLogoOnboarding.propTypes = {
  direction: string,
};

export default CompanyLogoOnboarding;
